enum AssetCondition {
    'NEW' = 'N',
    'USED' = 'U',
}

export default AssetCondition
